export default __webpack_public_path__ + "static/media/le_touquet6.a7bb344e.jpg";